import { useEffect, useState, useCallback } from 'react';

export interface Section {
  id: string;
  title: string;
  badgeNumber?: number;
}

export const useActiveSection = (sections: Section[]) => {
  const [visibleSections, setVisibleSections] = useState<Set<string>>(new Set());
  const [activeHref, setActiveHref] = useState(`#${sections[0]?.id || ''}`);

  const onChange = useCallback((id: string, visible: boolean) => {
    setVisibleSections((prev) => {
      const next = new Set(prev);

      if (visible) {
        next.add(id);
      } else {
        next.delete(id);
      }

      return next;
    });
  }, []);

  useEffect(() => {
    if (visibleSections.size === 0) return;

    const firstSection = sections[0];
    const newId = visibleSections.has(firstSection.id)
      ? firstSection.id
      : sections.find((s) => visibleSections.has(s.id))?.id;

    if (newId) {
      const newHref = `#${newId}`;
      setActiveHref((current) => (current !== newHref ? newHref : current));
    }
  }, [visibleSections, sections]);

  return { activeHref, setActiveHref, onChange };
};
